import { AbstractWinDisplayProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractWinDisplayProperties";
/**
 * WinDisplayLandscapeProperties.ts
 */
export class WinDisplayLandscapeProperties extends AbstractWinDisplayProperties {
}
//# sourceMappingURL=WinDisplayLandscapeProperties.js.map